// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_mv-0";